var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M7,11H9a.5.5,0,0,0,0-1H7a.5.5,0,0,0,0,1ZM3,11H5a.5.5,0,0,0,0-1H3a.5.5,0,0,0,0,1ZM14.5,2H2.5a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h12a2,2,0,0,0,2-2V4A2,2,0,0,0,14.5,2Zm1,10a1,1,0,0,1-1,1H2.5a1,1,0,0,1-1-1V8h14v4Zm0-5H1.5V4a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1Z",
    transform: "translate(-0.5 -2)",
    fill: "#181f38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockHeader);
export default __webpack_public_path__ + "static/media/block_header.fc28751a7a1f380a1675420f5a5a5820.svg";
export { ForwardRef as ReactComponent };